import { Component, Event, EventEmitter, h, Prop } from '@stencil/core';

@Component({
  tag: 'save-button',
  shadow: false,
})
export class SendButton {
  @Prop() name: string;
  @Prop() label: string;

  @Event() saveButtonClick: EventEmitter;

  saveButtonClickHandler(event: MouseEvent) {
    this.saveButtonClick.emit(event);
    console.log('saveButtonClickHandler', event);
  }

  render() {
    return (
      <div class="d-grid gap-2 d-md-flex justify-content-md-center mx-1">
        <button type="submit" class="btn btn-secondary" id="liveToastBtn" onClick={event => this.saveButtonClickHandler(event)}>
          <i class="bi bi-floppy2-fill me-2"></i>
          {this.label}
        </button>
      </div>
    );
  }
}
